const  CreditLineIcon = () => {
    return (
        <svg className={"svg-icon"} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.69531 17.25V19.5C4.69531 19.6989 4.77433 19.8897 4.91498 20.0303C5.05563 20.171 5.2464 20.25 5.44531 20.25H15.6347C15.7331 20.25 15.8307 20.2306 15.9217 20.1929C16.0127 20.1552 16.0953 20.1 16.165 20.0303L20.9756 15.2197C21.0453 15.15 21.1005 15.0673 21.1382 14.9764C21.1759 14.8854 21.1953 14.7878 21.1953 14.6893V9M4.69531 10.875V4.5C4.69531 4.30109 4.77433 4.11032 4.91498 3.96967C5.05563 3.82902 5.2464 3.75 5.44531 3.75H16.9453"
                stroke="#141615" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M21.9453 4L13.6376 12.25L10.1761 8.8125L3.94531 15" stroke="#141615" strokeWidth="2"
                  strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M21.1275 14.9993H15.9453V20.1818" stroke="#141615" strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    )
}

export default CreditLineIcon